import React from 'react';
import { StarIcon, TruckIcon, MapPinIcon, ShieldCheckIcon } from 'lucide-react';
export function SocialProofBar() {
  const proofItems = [{
    icon: TruckIcon,
    iconColor: 'text-brand-green',
    line1: 'FREE Local Delivery',
    line2: 'Within 5km*'
  }, {
    icon: StarIcon,
    iconColor: 'text-yellow-400 fill-current',
    line1: '4.6/5 Rated',
    line2: '6 Stores'
  }, {
    icon: null,
    image: 'https://cdn.magicpatterns.com/uploads/cHcSSRvAwPTr86uE9Kk5yi/WA_OWned.webp',
    line1: 'Proudly WA Owned',
    line2: 'Open 7 Days'
  }, {
    icon: MapPinIcon,
    iconColor: 'text-brand-blue',
    line1: 'Click & Collect',
    line2: 'Ready in 2hrs'
  }, {
    icon: ShieldCheckIcon,
    iconColor: 'text-brand-blue',
    line1: 'Price Match',
    line2: 'Guarantee'
  }];
  return <div className="relative z-20 flex flex-col" data-id="element-191">
      <div className="bg-white border-b border-gray-200" data-id="element-192">
        <div className="container-wide" data-id="element-193">
          {/* Desktop: Grid */}
          <div className="hidden md:grid md:grid-cols-5 divide-x divide-gray-100" data-id="element-194">
            {proofItems.map((item, index) => <div key={index} className="flex items-center justify-center gap-2.5 py-3 px-3 text-center" data-id="element-195">
                {item.icon ? <item.icon className={`w-5 h-5 ${item.iconColor} flex-shrink-0`} data-id="element-196" /> : item.image ? <img src={item.image} alt="WA Owned" className="w-5 h-5 rounded-full object-cover shadow-sm flex-shrink-0" data-id="element-197" /> : null}
                <div className="flex flex-col items-start" data-id="element-198">
                  <span className="text-xs font-bold text-gray-900 leading-tight" data-id="element-199">
                    {item.line1}
                  </span>
                  <span className="text-[11px] font-medium text-gray-500 leading-tight" data-id="element-200">
                    {item.line2}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Mobile: Horizontal Scroll */}
          <div className="md:hidden flex overflow-x-auto scrollbar-hide gap-6 py-3 px-4 snap-x snap-mandatory" data-id="element-201">
            {proofItems.map((item, index) => <div key={index} className="flex items-center gap-2.5 flex-shrink-0 snap-start" data-id="element-202">
                {item.icon ? <item.icon className={`w-5 h-5 ${item.iconColor} flex-shrink-0`} data-id="element-203" /> : item.image ? <img src={item.image} alt="WA Owned" className="w-5 h-5 rounded-full object-cover shadow-sm flex-shrink-0" data-id="element-204" /> : null}
                <div className="flex flex-col items-start" data-id="element-205">
                  <span className="text-xs font-bold text-gray-900 leading-tight whitespace-nowrap" data-id="element-206">
                    {item.line1}
                  </span>
                  <span className="text-[11px] font-medium text-gray-500 leading-tight whitespace-nowrap" data-id="element-207">
                    {item.line2}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}